export enum SelectionSetId {
	Null = -1,

	StockControllingOverviewFilter = 1,
	DeepdiveProductList = 2,
	HeatMapGroup = 3,
	IssueDevelopmentList = 4,
	ForecastingDeepDiveList = 6,
	ForecastingDeepdiveMasterData = 7,
	ForecastingValidationLogList = 8,
	ForecastingValidtionLogFilter = 9,
	ForecastingUserLimitationField = 10,
	ForecastingOverviewList = 11,
	ForecastingOverviewFilter = 12,
	ForecastingAccuracyFilter = 13,
	ForecastingAccuracyList = 14,
	ForecastDetailedPosting = 15,
	EsoDetailedPosting = 16,
	DecisionTreeFilters = 17,
	DecisionTreeList = 18,
	ForecastDeepdiveProductList = 0,
	StockControllingDeepDiveIssue = 19,
	ForecastingAccuracyTotalChart = 23,
	ForecastingAccuracyChart = 24,
	ForecastingAccuracyBiasChart = 25,
	ForecastingAccuracyErrorChart = 26,
	EsoOverviewList = 28,
	EsoOverviewFilters = 29,
	TaskListGridData = 30,
	ManualInputData = 31,
	ForecastOverviewTable = 32,
	EsoDetailedPostingsList = 33,
	ForecastDetailedPostingsList = 34,
	HeatMapFilters = 36,
	StatisticalForecastOverviewFilter = 37,
	StatisticalForecastOverviewList = 41,
	StatisticalForecastOverviewTable = 42,
	StatisticalForecastDeepDiveTableData = 45,
	StatisticalForecastDeepDiveList = 46,
	IssueDevelopmentListFilter = 47,
	EsoSimulateMultiGrid = 50,
	EsoSimulateMultiFilters = 51,
	EsoDeepDiveGrid = 52,
	ForecastActivityGroupsTableDataFields = 53,
	ForecastActivityGeneralTableDataFields = 54,
	ForecastActivitiesGridDataFields = 55,
	ForecastActivityListItemsGridDataFields = 56,
	ForecastActivitiesGridDataFilters = 57,
	ForecastActivitiesListsGridDataFilters = 58,
	ForecastActivitiesListsGridDataFields = 59,

	ReplenishmentOverviewFilters = 60,
	ReplenishmentOverviewFields = 61,

	ForecastActivitiesResultsGridDataFilters = 64,
	ForecastActivitiesResultsGridDataFields = 65,
	ForecastActivitiesResultsChartDataFields = 66,
	EsoNetworkDeepDiveSourcingTreeListDataFields = 68,

	EsoSupplyForecastTableFields = 72,
	EsoSupplyForecastFilters = 73,

	ProjectDeepDiveGridDataFilters = 77,
	ProjectDeepDiveGridDataFields = 78,

	CapacityOverviewFilters = 67,
	CapacityOverviewChartData = 69,
	CapacityOverviewTableFields = 75,
	CapacityOverviewList = 79,

	CapacityDeepDiveInfoGridDataFields = 80,
	CapacityDeepDiveTreeListFields = 71,

	MapFilters = 84,
	MapData = 85,

	EsoStockProjection = 88,
	EsoStockProjectionFilters = 90,
	EsoStockProjectionGridFields = 94,

	EsoNetworkDeepDiveProductDetailsData = 95,

	CapacityMatrix = 96,
	CapacityMatrixWeek = 97,
	BubbleMapFilters = 98,

	OrderOptimizerOrderLineData = 99,
	OrderOptimizerOrderData = 102,
	OrderOptimizerSupplierData = 103,

	TaskList = 104,
	GeneralProjectDeepDive = 105,

	OrderOptimizerReplenishmentFilters = 100,
	OrderOptimizerReplenishmentData = 101,
	OrderOptimizerOverView = 133, 
	EsoNetworkDeepDiveOrderByColumnNameItems = 136,
	OrderOptimizerMasterData = 138,
}
